import { render } from "./pager.vue?vue&type=template&id=65a227e5&scoped=true"
import script from "./pager.vue?vue&type=script&lang=js"
export * from "./pager.vue?vue&type=script&lang=js"

import "./pager.vue?vue&type=style&index=0&id=65a227e5&scoped=true&lang=css"

import exportComponent from "D:\\zhang\\项目\\经皮黄疸仪\\jaundiceweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a227e5"]])

export default __exports__